export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_SIGN_LANGUAGE.f9010ffe.svg";